<template>
  <VModal name="add-edit-prefill-types-modal" size="small" class="add-edit-prefill-types-modal" :loading="loading" @onOpen="onOpen">
    <template v-slot:header>
      <h2 class="o-modal__box__header">{{ $t('createEnvelope.documentSetup.fieldConfiguration.addEditPrefillTypesModal.addOrEdit') }}</h2>
    </template>
    <template v-slot:content>
      <div class="add-edit-prefill-types-modal__box__content">
        <div class="add-edit-prefill-types-modal__search">
          <VInput
            type="text"
            :placeholder="$t('createEnvelope.documentSetup.fieldConfiguration.addEditPrefillTypesModal.searchPlaceholder')"
            v-model="searchText"
            :icon="true"
            :fluid="true"
            data-ec="template_edit_add_edit_prefill_types_modal"
            data-et="search_input">
            <SearchIcon />
          </VInput>
        </div>
        <div class="add-edit-prefill-types-modal__add-field">
          <VInput
            type="text"
            :placeholder="$t('createEnvelope.documentSetup.fieldConfiguration.addEditPrefillTypesModal.addPrefillTypePlaceholder')"
            @updated="addPrefillType"
            v-model="addPrefillTypeName"
            data-ec="template_edit_add_edit_prefill_types_modal"
            data-et="add_prefill_type_input"
            :icon="true"
            :fluid="true"
            data-hj-suppress>
            <PlusCircleIcon />
          </VInput>
        </div>
        <div class="add-edit-prefill-types-modal__list-item add-edit-prefill-types-modal__list-item--no-results" v-if="noResults">
          {{ $t('createEnvelope.documentSetup.fieldConfiguration.addEditPrefillTypesModal.noResults') }}
        </div>
        <div v-else class="add-edit-prefill-types-modal__list">
          <div
            :class="{
              'add-edit-prefill-types-modal__list-item': true,
              'add-edit-prefill-types-modal__list-item--active': field.active,
            }"
            v-for="(field, index) in fields"
            :key="field.id"
            data-ec="add_edit_prefill_types_modal"
            :data-et="`select_prefill_type_${field.merge_field}`"
            @click="selectPrefillType"
            :data-index="index">
            <span class="add-edit-prefill-types-modal__list-item__text">{{ field.merge_field }}</span>
            <CheckCircleIcon v-if="field.active" />
          </div>
        </div>
        <i18n class="add-edit-prefill-types-modal__currentlySelectedText" path="createEnvelope.documentSetup.fieldConfiguration.addEditPrefillTypesModal.currentlySelected" tag="p">
          <template v-slot:selected>
            <b> {{ assignedPrefillTypeLabel }}</b>
          </template>
        </i18n>
        <VButton
          data-ec="template_edit_add_edit_prefill_types_modal"
          data-et="assign_button"
          class="add-edit-prefill-types-modal__assign-button"
          type="outline-1"
          @click="assignPrefillType"
          :disabled="!selectedPrefillType">
          <span>{{ $t('functional.assign') }}</span>
        </VButton>
      </div>
    </template>
  </VModal>
</template>

<script>
import VButton from '@/components/deprecated/atoms/Button.vue';
import VInput from '@/components/deprecated/atoms/Input.vue';
import VModal from '@/components/deprecated/organisms/Modal.vue';
import { CheckCircleIcon, PlusCircleIcon, SearchIcon } from '@/components/icons/fontIcons';

export default {
  name: 'addEditPrefillTypesModal', // ex AddEditMergeFieldsModal, this component was renamed
  props: {
    field: {
      type: [Object],
      required: true,
    },
    prefillTypes: {
      type: [Array],
    },
  },
  components: {
    VInput,
    VModal,
    VButton,
    CheckCircleIcon,
    PlusCircleIcon,
    SearchIcon,
  },
  data() {
    return {
      searchText: '',
      searchFields: [],
      addPrefillTypeName: '',
      loading: false,
    };
  },
  computed: {
    assignedPrefillTypeLabel() {
      return this.selectedPrefillType ? this.selectedPrefillType.merge_field : this.$t('functional.none');
    },
    fields: {
      get() {
        if (this.searchFields.length > 0 && this.searchText !== '') {
          return this.searchFields;
        }

        return this.prefillTypes;
      },
      set(value) {
        return value;
      },
    },
    noResults() {
      return this.searchFields.length === 0 && this.searchText !== '';
    },
    mergeFieldHasBeenSelected() {
      return this.fields.filter(item => item.active).length === 1;
    },
    selectedPrefillType() {
      return this.fields.filter(item => item.active)[0];
    },
  },
  methods: {
    onOpen() {
      this.fields = this.fields.map((item) => {
        if (this.field.merge_field === item.merge_field) {
          this.$set(item, 'active', true); // field.active = true;
        } else {
          this.$set(item, 'active', false); // field.active = false;
        }
        return item;
      });
    },
    search(value) {
      this.searchFields = this.prefillTypes.filter(field => field.merge_field.toLowerCase().indexOf(value.toLowerCase()) > -1);
    },
    selectPrefillType($event) {
      const index = $event.target.getAttribute('data-index');
      const field = this.fields[index];

      this.searchFields = [];
      this.searchText = '';

      // allowing toggling on field
      this.fields = this.prefillTypes.map((item) => {
        const returnField = item;
        if (field.merge_field === returnField.merge_field) {
          returnField.active = !returnField.active;
        } else {
          returnField.active = false;
        }

        return returnField;
      });
    },
    addPrefillType(value) {
      this.addPrefillTypeName = '';
      this.loading = true;

      if (value) {
        this.$store.dispatch('company/ADD_MERGE_FIELD', { mergeField: value }).then(() => {
          this.$emit('updated', value);
        }).finally(() => {
          this.loading = false;
        });
      }
    },
    assignPrefillType() {
      const choice = this.selectedPrefillType.merge_field;
      this.$emit('updated', choice);
      this.$bus.$emit('closeModal');
    },
  },
  watch: {
    searchText: {
      handler(value) {
        this.search(value);
      },
    },
  },
};
</script>

<style scoped>
.add-edit-prefill-types-modal ::v-deep .o-modal__box__content {
  height: 485px;
  min-height: 300px;
  overflow: auto;
}

.add-edit-prefill-types-modal__search, .add-edit-prefill-types-modal__add-field {
  margin-bottom: var(--spacing-base);
}

.add-edit-prefill-types-modal__search:after, .add-edit-prefill-types-modal__add-field:after {
  content: '';
  display: block;
  clear: both;
}

.add-edit-prefill-types-modal__list {
  height: 33vh;
  max-height: 290px;
  overflow: scroll;
}

.add-edit-prefill-types-modal__assign-button {
  position: absolute;
  right: var(--spacing-base);
  bottom: var(--spacing-base);
}

.add-edit-prefill-types-modal__currentlySelectedText {
  position: absolute;
  bottom: var(--spacing-xs);
}

.add-edit-prefill-types-modal__list-item {
  padding: var(--spacing-small);
  margin-top: var(--spacing-small);
  background: var(--signable-secondary-2);
  border-radius: 3px;
  color: #fff;
  cursor: pointer;
}

.add-edit-prefill-types-modal__list-item:hover {
  background: var(--signable-secondary-2-shade-2);
}

.add-edit-prefill-types-modal__list-item--active {
  background: var(--signable-primary-1);
}

.add-edit-prefill-types-modal__list-item--active:hover {
  background: var(--signable-primary-1);
}

.add-edit-prefill-types-modal__list-item--active ::v-deep svg {
  float: right;
}

.add-edit-prefill-types-modal__list-item--no-results {
  background: var(--color-warning);
}

.add-edit-prefill-types-modal__list-item--no-results:hover {
  background: var(--color-warning);
}

.add-edit-prefill-types-modal__list-item__text {
  pointer-events: none;
}

.add-edit-prefill-types-modal__list-item:first-of-type {
  margin-top: 0;
}
</style>
